"use client";

import { useEffect } from "react";
import { useReflectProjectionStore } from "@/lib/stores/reflectProjection";

export function useReflectProjection() {
  const data = useReflectProjectionStore((state) => state.data);
  const status = useReflectProjectionStore((state) => state.status);
  const error = useReflectProjectionStore((state) => state.error);
  const lastLoadedAt = useReflectProjectionStore((state) => state.lastLoadedAt);
  const lastInvalidatedAt = useReflectProjectionStore((state) => state.lastInvalidatedAt);
  const fetch = useReflectProjectionStore((state) => state.fetch);
  const refresh = useReflectProjectionStore((state) => state.refresh);

  useEffect(() => {
    if ((status === "idle" || status === "error") && !data) {
      void fetch();
    }
  }, [data, fetch, status]);

  useEffect(() => {
    if (!lastInvalidatedAt || status === "loading") return;
    if (lastLoadedAt && lastInvalidatedAt <= lastLoadedAt) return;
    void refresh();
  }, [lastInvalidatedAt, lastLoadedAt, refresh, status]);

  return {
    projection: data,
    status,
    error,
    refresh,
  };
}
